import { GET_TEAMS } from "constants/teams";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_TEAMS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
